module.exports = __webpack_public_path__ + "img/header_halloween.0656974.png";